export const PRIMARY_FONT = `"Hurricane", cursive;`;
export const SECONDARY_FONT = `"Cormorant Upright", serif;`;
export const FANTASY = PRIMARY_FONT;
export const CURSIVE = PRIMARY_FONT;
